import { Blockquote, Box, Text } from '@mantine/core';

import { IntegrationHelperTextConfigField } from '@/types/integrations.ts';

type props = {
  field: IntegrationHelperTextConfigField;
};

const HelperTextField = ({ field }: props) => {
  return (
    <>
      <Box pos="relative">
        <Blockquote color="brandPink" p={'xs'} variant={'outline'}>
          <Text size={'sm'} style={{ whiteSpace: 'pre-line' }}>
            {field.description}
          </Text>
        </Blockquote>
      </Box>
    </>
  );
};

export default HelperTextField;
